import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-brand-cream px-6 text-center">
      <p className="font-display font-black text-7xl text-brand-blue">404</p>
      <p className="mt-4 text-lg text-brand-black/70">This page could not be found.</p>
      <Link
        to="/"
        className="mt-6 inline-flex items-center bg-brand-gold text-black font-semibold px-6 py-3 border-2 border-black rounded-md shadow-brutal hover:-translate-y-0.5 transition-all"
        data-testid="notfound-home-link"
      >
        Back to home
      </Link>
    </div>
  );
}
